import React from "react";
import { Paragraph, Modal } from "@vwfs-bronson/bronson-react";
import { AxiosError } from "axios";
import { ProductModifier } from "@busdk/storefront-service/dist/models/enums";
import { Output } from '../Text';
import { abortJourney } from '../services/api/integrationService';

class AbortModal extends React.Component<AbortModalType> {
  closeModal = () => {
    this.props.setShown(false);
  };

  redirect = async () => {
    await abortJourney(this.props.transactionId, this.props.productModifier)
      .then(() => {
        window.location.href = this.props.redirectUri;
      })
      .catch((err: AxiosError) => {
        console.error(
          `Either the storefront service or the integration service is not reachable:\n${err}`
        );
      });
  };

  render() {
    return (
      <Modal
        shown={this.props.shown}
        title={Output.resolve("pages.leasing.abortModal.title")}
        buttonConfirmText={Output.resolve("pages.leasing.abortModal.confirm")}
        buttonCancelText={Output.resolve("pages.leasing.abortModal.cancel")}
        onCancel={this.closeModal}
        onConfirm={this.redirect}
        hideCloseButton
        testId="abort-modal"
      >
        <Paragraph>
          {Output.resolve("pages.leasing.abortModal.content")}
        </Paragraph>
      </Modal>
    );
  }
}

type AbortModalType = {
  shown: boolean;
  setShown: Function;
  redirectUri: string;
  transactionId: string;
  productModifier: ProductModifier;
};

export { AbortModal };
